const LocalTimeZone = Object.freeze({
  GMT: 'GMT',
  AFRICA_ABIDJAN: 'AFRICA_ABIDJAN',
  AFRICA_ACCRA: 'AFRICA_ACCRA',
  AFRICA_ADDISABABA: 'AFRICA_ADDISABABA',
  AFRICA_ALGIERS: 'AFRICA_ALGIERS',
  AFRICA_ASMERA: 'AFRICA_ASMERA',
  AFRICA_BAMAKO: 'AFRICA_BAMAKO',
  AFRICA_BANGUI: 'AFRICA_BANGUI',
  AFRICA_BANJUL: 'AFRICA_BANJUL',
  AFRICA_BISSAU: 'AFRICA_BISSAU',
  AFRICA_BLANTYRE: 'AFRICA_BLANTYRE',
  AFRICA_BRAZZAVILLE: 'AFRICA_BRAZZAVILLE',
  AFRICA_BUJUMBURA: 'AFRICA_BUJUMBURA',
  AFRICA_CAIRO: 'AFRICA_CAIRO',
  AFRICA_CASABLANCA: 'AFRICA_CASABLANCA',
  AFRICA_CEUTA: 'AFRICA_CEUTA',
  AFRICA_CONAKRY: 'AFRICA_CONAKRY',
  AFRICA_DAKAR: 'AFRICA_DAKAR',
  AFRICA_DARESSALAAM: 'AFRICA_DARESSALAAM',
  AFRICA_DJIBOUTI: 'AFRICA_DJIBOUTI',
  AFRICA_DOUALA: 'AFRICA_DOUALA',
  AFRICA_ELAAIUN: 'AFRICA_ELAAIUN',
  AFRICA_FREETOWN: 'AFRICA_FREETOWN',
  AFRICA_GABORONE: 'AFRICA_GABORONE',
  AFRICA_HARARE: 'AFRICA_HARARE',
  AFRICA_JOHANNESBURG: 'AFRICA_JOHANNESBURG',
  AFRICA_KAMPALA: 'AFRICA_KAMPALA',
  AFRICA_KHARTOUM: 'AFRICA_KHARTOUM',
  AFRICA_KIGALI: 'AFRICA_KIGALI',
  AFRICA_KINSHASA: 'AFRICA_KINSHASA',
  AFRICA_LAGOS: 'AFRICA_LAGOS',
  AFRICA_LIBREVILLE: 'AFRICA_LIBREVILLE',
  AFRICA_LOME: 'AFRICA_LOME',
  AFRICA_LUANDA: 'AFRICA_LUANDA',
  AFRICA_LUBUMBASHI: 'AFRICA_LUBUMBASHI',
  AFRICA_LUSAKA: 'AFRICA_LUSAKA',
  AFRICA_MALABO: 'AFRICA_MALABO',
  AFRICA_MAPUTO: 'AFRICA_MAPUTO',
  AFRICA_MASERU: 'AFRICA_MASERU',
  AFRICA_MBABANE: 'AFRICA_MBABANE',
  AFRICA_MOGADISHU: 'AFRICA_MOGADISHU',
  AFRICA_MONROVIA: 'AFRICA_MONROVIA',
  AFRICA_NAIROBI: 'AFRICA_NAIROBI',
  AFRICA_NDJAMENA: 'AFRICA_NDJAMENA',
  AFRICA_NIAMEY: 'AFRICA_NIAMEY',
  AFRICA_NOUAKCHOTT: 'AFRICA_NOUAKCHOTT',
  AFRICA_OUAGADOUGOU: 'AFRICA_OUAGADOUGOU',
  AFRICA_PORTONOVO: 'AFRICA_PORTONOVO',
  AFRICA_SAOTOME: 'AFRICA_SAOTOME',
  AFRICA_TRIPOLI: 'AFRICA_TRIPOLI',
  AFRICA_TUNIS: 'AFRICA_TUNIS',
  AFRICA_WINDHOEK: 'AFRICA_WINDHOEK',
  AMERICA_ADAK: 'AMERICA_ADAK',
  AMERICA_ANCHORAGE: 'AMERICA_ANCHORAGE',
  AMERICA_ANGUILLA: 'AMERICA_ANGUILLA',
  AMERICA_ANTIGUA: 'AMERICA_ANTIGUA',
  AMERICA_ARAGUAINA: 'AMERICA_ARAGUAINA',
  AMERICA_ARGENTINA_LARIOJA: 'AMERICA_ARGENTINA_LARIOJA',
  AMERICA_ARGENTINA_RIOGALLEGOS: 'AMERICA_ARGENTINA_RIOGALLEGOS',
  AMERICA_ARGENTINA_SANJUAN: 'AMERICA_ARGENTINA_SANJUAN',
  AMERICA_ARGENTINA_TUCUMAN: 'AMERICA_ARGENTINA_TUCUMAN',
  AMERICA_ARGENTINA_USHUAIA: 'AMERICA_ARGENTINA_USHUAIA',
  AMERICA_ARUBA: 'AMERICA_ARUBA',
  AMERICA_ASUNCION: 'AMERICA_ASUNCION',
  AMERICA_BAHIA: 'AMERICA_BAHIA',
  AMERICA_BARBADOS: 'AMERICA_BARBADOS',
  AMERICA_BELEM: 'AMERICA_BELEM',
  AMERICA_BELIZE: 'AMERICA_BELIZE',
  AMERICA_BLANCSABLON: 'AMERICA_BLANCSABLON',
  AMERICA_BOAVISTA: 'AMERICA_BOAVISTA',
  AMERICA_BOGOTA: 'AMERICA_BOGOTA',
  AMERICA_BOISE: 'AMERICA_BOISE',
  AMERICA_BUENOSAIRES: 'AMERICA_BUENOSAIRES',
  AMERICA_CAMBRIDGEBAY: 'AMERICA_CAMBRIDGEBAY',
  AMERICA_CAMPOGRANDE: 'AMERICA_CAMPOGRANDE',
  AMERICA_CANCUN: 'AMERICA_CANCUN',
  AMERICA_CARACAS: 'AMERICA_CARACAS',
  AMERICA_CATAMARCA: 'AMERICA_CATAMARCA',
  AMERICA_CAYENNE: 'AMERICA_CAYENNE',
  AMERICA_CAYMAN: 'AMERICA_CAYMAN',
  AMERICA_CHICAGO: 'AMERICA_CHICAGO',
  AMERICA_CHIHUAHUA: 'AMERICA_CHIHUAHUA',
  AMERICA_CORALHARBOUR: 'AMERICA_CORALHARBOUR',
  AMERICA_CORDOBA: 'AMERICA_CORDOBA',
  AMERICA_COSTARICA: 'AMERICA_COSTARICA',
  AMERICA_CUIABA: 'AMERICA_CUIABA',
  AMERICA_CURACAO: 'AMERICA_CURACAO',
  AMERICA_DANMARKSHAVN: 'AMERICA_DANMARKSHAVN',
  AMERICA_DAWSON: 'AMERICA_DAWSON',
  AMERICA_DAWSONCREEK: 'AMERICA_DAWSONCREEK',
  AMERICA_DENVER: 'AMERICA_DENVER',
  AMERICA_DETROIT: 'AMERICA_DETROIT',
  AMERICA_DOMINICA: 'AMERICA_DOMINICA',
  AMERICA_EDMONTON: 'AMERICA_EDMONTON',
  AMERICA_EIRUNEPE: 'AMERICA_EIRUNEPE',
  AMERICA_ELSALVADOR: 'AMERICA_ELSALVADOR',
  AMERICA_FORTALEZA: 'AMERICA_FORTALEZA',
  AMERICA_GLACEBAY: 'AMERICA_GLACEBAY',
  AMERICA_GODTHAB: 'AMERICA_GODTHAB',
  AMERICA_GOOSEBAY: 'AMERICA_GOOSEBAY',
  AMERICA_GRANDTURK: 'AMERICA_GRANDTURK',
  AMERICA_GRENADA: 'AMERICA_GRENADA',
  AMERICA_GUADELOUPE: 'AMERICA_GUADELOUPE',
  AMERICA_GUATEMALA: 'AMERICA_GUATEMALA',
  AMERICA_GUAYAQUIL: 'AMERICA_GUAYAQUIL',
  AMERICA_GUYANA: 'AMERICA_GUYANA',
  AMERICA_HALIFAX: 'AMERICA_HALIFAX',
  AMERICA_HAVANA: 'AMERICA_HAVANA',
  AMERICA_HERMOSILLO: 'AMERICA_HERMOSILLO',
  AMERICA_INDIANAKNOX: 'AMERICA_INDIANAKNOX',
  AMERICA_INDIANAMARENGO: 'AMERICA_INDIANAMARENGO',
  AMERICA_INDIANAPETERSBURG: 'AMERICA_INDIANAPETERSBURG',
  AMERICA_INDIANAPOLIS: 'AMERICA_INDIANAPOLIS',
  AMERICA_INDIANAVEVAY: 'AMERICA_INDIANAVEVAY',
  AMERICA_INDIANAVINCENNES: 'AMERICA_INDIANAVINCENNES',
  AMERICA_INUVIK: 'AMERICA_INUVIK',
  AMERICA_IQALUIT: 'AMERICA_IQALUIT',
  AMERICA_JAMAICA: 'AMERICA_JAMAICA',
  AMERICA_JUJUY: 'AMERICA_JUJUY',
  AMERICA_JUNEAU: 'AMERICA_JUNEAU',
  AMERICA_KENTUCKYMONTICELLO: 'AMERICA_KENTUCKYMONTICELLO',
  AMERICA_LAPAZ: 'AMERICA_LAPAZ',
  AMERICA_LIMA: 'AMERICA_LIMA',
  AMERICA_LOSANGELES: 'AMERICA_LOSANGELES',
  AMERICA_LOUISVILLE: 'AMERICA_LOUISVILLE',
  AMERICA_MACEIO: 'AMERICA_MACEIO',
  AMERICA_MANAGUA: 'AMERICA_MANAGUA',
  AMERICA_MANAUS: 'AMERICA_MANAUS',
  AMERICA_MARTINIQUE: 'AMERICA_MARTINIQUE',
  AMERICA_MAZATLAN: 'AMERICA_MAZATLAN',
  AMERICA_MENDOZA: 'AMERICA_MENDOZA',
  AMERICA_MENOMINEE: 'AMERICA_MENOMINEE',
  AMERICA_MERIDA: 'AMERICA_MERIDA',
  AMERICA_MEXICOCITY: 'AMERICA_MEXICOCITY',
  AMERICA_MIQUELON: 'AMERICA_MIQUELON',
  AMERICA_MONCTON: 'AMERICA_MONCTON',
  AMERICA_MONTERREY: 'AMERICA_MONTERREY',
  AMERICA_MONTEVIDEO: 'AMERICA_MONTEVIDEO',
  AMERICA_MONTREAL: 'AMERICA_MONTREAL',
  AMERICA_MONTSERRAT: 'AMERICA_MONTSERRAT',
  AMERICA_NASSAU: 'AMERICA_NASSAU',
  AMERICA_NEWYORK: 'AMERICA_NEWYORK',
  AMERICA_NIPIGON: 'AMERICA_NIPIGON',
  AMERICA_NOME: 'AMERICA_NOME',
  AMERICA_NORONHA: 'AMERICA_NORONHA',
  AMERICA_NORTHDAKOTACENTER: 'AMERICA_NORTHDAKOTACENTER',
  AMERICA_NORTHDAKOTANEWSALEM: 'AMERICA_NORTHDAKOTANEWSALEM',
  AMERICA_PANAMA: 'AMERICA_PANAMA',
  AMERICA_PANGNIRTUNG: 'AMERICA_PANGNIRTUNG',
  AMERICA_PARAMARIBO: 'AMERICA_PARAMARIBO',
  AMERICA_PHOENIX: 'AMERICA_PHOENIX',
  AMERICA_PORTAUPRINCE: 'AMERICA_PORTAUPRINCE',
  AMERICA_PORTOFSPAIN: 'AMERICA_PORTOFSPAIN',
  AMERICA_PORTOVELHO: 'AMERICA_PORTOVELHO',
  AMERICA_PUERTORICO: 'AMERICA_PUERTORICO',
  AMERICA_RAINYRIVER: 'AMERICA_RAINYRIVER',
  AMERICA_RANKININLET: 'AMERICA_RANKININLET',
  AMERICA_RECIFE: 'AMERICA_RECIFE',
  AMERICA_REGINA: 'AMERICA_REGINA',
  AMERICA_RIOBRANCO: 'AMERICA_RIOBRANCO',
  AMERICA_SANTIAGO: 'AMERICA_SANTIAGO',
  AMERICA_SANTODOMINGO: 'AMERICA_SANTODOMINGO',
  AMERICA_SAOPAULO: 'AMERICA_SAOPAULO',
  AMERICA_SCORESBYSUND: 'AMERICA_SCORESBYSUND',
  AMERICA_SHIPROCK: 'AMERICA_SHIPROCK',
  AMERICA_STJOHNS: 'AMERICA_STJOHNS',
  AMERICA_STKITTS: 'AMERICA_STKITTS',
  AMERICA_STLUCIA: 'AMERICA_STLUCIA',
  AMERICA_STTHOMAS: 'AMERICA_STTHOMAS',
  AMERICA_STVINCENT: 'AMERICA_STVINCENT',
  AMERICA_SWIFTCURRENT: 'AMERICA_SWIFTCURRENT',
  AMERICA_TEGUCIGALPA: 'AMERICA_TEGUCIGALPA',
  AMERICA_THULE: 'AMERICA_THULE',
  AMERICA_THUNDERBAY: 'AMERICA_THUNDERBAY',
  AMERICA_TIJUANA: 'AMERICA_TIJUANA',
  AMERICA_TORONTO: 'AMERICA_TORONTO',
  AMERICA_TORTOLA: 'AMERICA_TORTOLA',
  AMERICA_VANCOUVER: 'AMERICA_VANCOUVER',
  AMERICA_WHITEHORSE: 'AMERICA_WHITEHORSE',
  AMERICA_WINNIPEG: 'AMERICA_WINNIPEG',
  AMERICA_YAKUTAT: 'AMERICA_YAKUTAT',
  AMERICA_YELLOWKNIFE: 'AMERICA_YELLOWKNIFE',
  ANTARCTICA_CASEY: 'ANTARCTICA_CASEY',
  ANTARCTICA_DAVIS: 'ANTARCTICA_DAVIS',
  ANTARCTICA_DUMONTDURVILLE: 'ANTARCTICA_DUMONTDURVILLE',
  ANTARCTICA_MAWSON: 'ANTARCTICA_MAWSON',
  ANTARCTICA_MCMURDO: 'ANTARCTICA_MCMURDO',
  ANTARCTICA_PALMER: 'ANTARCTICA_PALMER',
  ANTARCTICA_ROTHERA: 'ANTARCTICA_ROTHERA',
  ANTARCTICA_SYOWA: 'ANTARCTICA_SYOWA',
  ANTARCTICA_VOSTOK: 'ANTARCTICA_VOSTOK',
  ASIA_ADEN: 'ASIA_ADEN',
  ASIA_ALMATY: 'ASIA_ALMATY',
  ASIA_AMMAN: 'ASIA_AMMAN',
  ASIA_ANADYR: 'ASIA_ANADYR',
  ASIA_AQTAU: 'ASIA_AQTAU',
  ASIA_AQTOBE: 'ASIA_AQTOBE',
  ASIA_ASHGABAT: 'ASIA_ASHGABAT',
  ASIA_BAGHDAD: 'ASIA_BAGHDAD',
  ASIA_BAHRAIN: 'ASIA_BAHRAIN',
  ASIA_BAKU: 'ASIA_BAKU',
  ASIA_BANGKOK: 'ASIA_BANGKOK',
  ASIA_BEIRUT: 'ASIA_BEIRUT',
  ASIA_BISHKEK: 'ASIA_BISHKEK',
  ASIA_BRUNEI: 'ASIA_BRUNEI',
  ASIA_CALCUTTA: 'ASIA_CALCUTTA',
  ASIA_CHOIBALSAN: 'ASIA_CHOIBALSAN',
  ASIA_CHONGQING: 'ASIA_CHONGQING',
  ASIA_COLOMBO: 'ASIA_COLOMBO',
  ASIA_DAMASCUS: 'ASIA_DAMASCUS',
  ASIA_DHAKA: 'ASIA_DHAKA',
  ASIA_DILI: 'ASIA_DILI',
  ASIA_DUBAI: 'ASIA_DUBAI',
  ASIA_DUSHANBE: 'ASIA_DUSHANBE',
  ASIA_GAZA: 'ASIA_GAZA',
  ASIA_HARBIN: 'ASIA_HARBIN',
  ASIA_HONGKONG: 'ASIA_HONGKONG',
  ASIA_HOVD: 'ASIA_HOVD',
  ASIA_IRKUTSK: 'ASIA_IRKUTSK',
  ASIA_JAKARTA: 'ASIA_JAKARTA',
  ASIA_JAYAPURA: 'ASIA_JAYAPURA',
  ASIA_JERUSALEM: 'ASIA_JERUSALEM',
  ASIA_KABUL: 'ASIA_KABUL',
  ASIA_KAMCHATKA: 'ASIA_KAMCHATKA',
  ASIA_KARACHI: 'ASIA_KARACHI',
  ASIA_KASHGAR: 'ASIA_KASHGAR',
  ASIA_KATMANDU: 'ASIA_KATMANDU',
  ASIA_KRASNOYARSK: 'ASIA_KRASNOYARSK',
  ASIA_KUALALUMPUR: 'ASIA_KUALALUMPUR',
  ASIA_KUCHING: 'ASIA_KUCHING',
  ASIA_KUWAIT: 'ASIA_KUWAIT',
  ASIA_MACAU: 'ASIA_MACAU',
  ASIA_MAGADAN: 'ASIA_MAGADAN',
  ASIA_MAKASSAR: 'ASIA_MAKASSAR',
  ASIA_MANILA: 'ASIA_MANILA',
  ASIA_MUSCAT: 'ASIA_MUSCAT',
  ASIA_NICOSIA: 'ASIA_NICOSIA',
  ASIA_NOVOSIBIRSK: 'ASIA_NOVOSIBIRSK',
  ASIA_OMSK: 'ASIA_OMSK',
  ASIA_ORAL: 'ASIA_ORAL',
  ASIA_PHNOMPENH: 'ASIA_PHNOMPENH',
  ASIA_PONTIANAK: 'ASIA_PONTIANAK',
  ASIA_PYONGYANG: 'ASIA_PYONGYANG',
  ASIA_QATAR: 'ASIA_QATAR',
  ASIA_QYZYLORDA: 'ASIA_QYZYLORDA',
  ASIA_RANGOON: 'ASIA_RANGOON',
  ASIA_RIYADH: 'ASIA_RIYADH',
  ASIA_SAIGON: 'ASIA_SAIGON',
  ASIA_SAKHALIN: 'ASIA_SAKHALIN',
  ASIA_SAMARKAND: 'ASIA_SAMARKAND',
  ASIA_SEOUL: 'ASIA_SEOUL',
  ASIA_SHANGHAI: 'ASIA_SHANGHAI',
  ASIA_SINGAPORE: 'ASIA_SINGAPORE',
  ASIA_TAIPEI: 'ASIA_TAIPEI',
  ASIA_TASHKENT: 'ASIA_TASHKENT',
  ASIA_TBILISI: 'ASIA_TBILISI',
  ASIA_TEHRAN: 'ASIA_TEHRAN',
  ASIA_THIMPHU: 'ASIA_THIMPHU',
  ASIA_TOKYO: 'ASIA_TOKYO',
  ASIA_ULAANBAATAR: 'ASIA_ULAANBAATAR',
  ASIA_URUMQI: 'ASIA_URUMQI',
  ASIA_VIENTIANE: 'ASIA_VIENTIANE',
  ASIA_VLADIVOSTOK: 'ASIA_VLADIVOSTOK',
  ASIA_YAKUTSK: 'ASIA_YAKUTSK',
  ASIA_YEKATERINBURG: 'ASIA_YEKATERINBURG',
  ASIA_YEREVAN: 'ASIA_YEREVAN',
  ATLANTIC_AZORES: 'ATLANTIC_AZORES',
  ATLANTIC_BERMUDA: 'ATLANTIC_BERMUDA',
  ATLANTIC_CANARY: 'ATLANTIC_CANARY',
  ATLANTIC_CAPEVERDE: 'ATLANTIC_CAPEVERDE',
  ATLANTIC_FAEROE: 'ATLANTIC_FAEROE',
  ATLANTIC_MADEIRA: 'ATLANTIC_MADEIRA',
  ATLANTIC_REYKJAVIK: 'ATLANTIC_REYKJAVIK',
  ATLANTIC_SOUTHGEORGIA: 'ATLANTIC_SOUTHGEORGIA',
  ATLANTIC_STANLEY: 'ATLANTIC_STANLEY',
  ATLANTIC_STHELENA: 'ATLANTIC_STHELENA',
  AUSTRALIA_ADELAIDE: 'AUSTRALIA_ADELAIDE',
  AUSTRALIA_BRISBANE: 'AUSTRALIA_BRISBANE',
  AUSTRALIA_BROKENHILL: 'AUSTRALIA_BROKENHILL',
  AUSTRALIA_CURRIE: 'AUSTRALIA_CURRIE',
  AUSTRALIA_DARWIN: 'AUSTRALIA_DARWIN',
  AUSTRALIA_EUCLA: 'AUSTRALIA_EUCLA',
  AUSTRALIA_HOBART: 'AUSTRALIA_HOBART',
  AUSTRALIA_LINDEMAN: 'AUSTRALIA_LINDEMAN',
  AUSTRALIA_LORDHOWE: 'AUSTRALIA_LORDHOWE',
  AUSTRALIA_MELBOURNE: 'AUSTRALIA_MELBOURNE',
  AUSTRALIA_PERTH: 'AUSTRALIA_PERTH',
  AUSTRALIA_SYDNEY: 'AUSTRALIA_SYDNEY',
  EUROPE_AMSTERDAM: 'EUROPE_AMSTERDAM',
  EUROPE_ANDORRA: 'EUROPE_ANDORRA',
  EUROPE_ATHENS: 'EUROPE_ATHENS',
  EUROPE_BELGRADE: 'EUROPE_BELGRADE',
  EUROPE_BERLIN: 'EUROPE_BERLIN',
  EUROPE_BRATISLAVA: 'EUROPE_BRATISLAVA',
  EUROPE_BRUSSELS: 'EUROPE_BRUSSELS',
  EUROPE_BUCHAREST: 'EUROPE_BUCHAREST',
  EUROPE_BUDAPEST: 'EUROPE_BUDAPEST',
  EUROPE_CHISINAU: 'EUROPE_CHISINAU',
  EUROPE_COPENHAGEN: 'EUROPE_COPENHAGEN',
  EUROPE_DUBLIN: 'EUROPE_DUBLIN',
  EUROPE_GIBRALTAR: 'EUROPE_GIBRALTAR',
  EUROPE_HELSINKI: 'EUROPE_HELSINKI',
  EUROPE_ISTANBUL: 'EUROPE_ISTANBUL',
  EUROPE_KALININGRAD: 'EUROPE_KALININGRAD',
  EUROPE_KIEV: 'EUROPE_KIEV',
  EUROPE_LISBON: 'EUROPE_LISBON',
  EUROPE_LJUBLJANA: 'EUROPE_LJUBLJANA',
  EUROPE_LONDON: 'EUROPE_LONDON',
  EUROPE_LUXEMBOURG: 'EUROPE_LUXEMBOURG',
  EUROPE_MADRID: 'EUROPE_MADRID',
  EUROPE_MALTA: 'EUROPE_MALTA',
  EUROPE_MINSK: 'EUROPE_MINSK',
  EUROPE_MONACO: 'EUROPE_MONACO',
  EUROPE_MOSCOW: 'EUROPE_MOSCOW',
  EUROPE_OSLO: 'EUROPE_OSLO',
  EUROPE_PARIS: 'EUROPE_PARIS',
  EUROPE_PODGORICA: 'EUROPE_PODGORICA',
  EUROPE_PRAGUE: 'EUROPE_PRAGUE',
  EUROPE_RIGA: 'EUROPE_RIGA',
  EUROPE_ROME: 'EUROPE_ROME',
  EUROPE_SAMARA: 'EUROPE_SAMARA',
  EUROPE_SARAJEVO: 'EUROPE_SARAJEVO',
  EUROPE_SIMFEROPOL: 'EUROPE_SIMFEROPOL',
  EUROPE_SKOPJE: 'EUROPE_SKOPJE',
  EUROPE_SOFIA: 'EUROPE_SOFIA',
  EUROPE_STOCKHOLM: 'EUROPE_STOCKHOLM',
  EUROPE_TALLINN: 'EUROPE_TALLINN',
  EUROPE_TIRANE: 'EUROPE_TIRANE',
  EUROPE_UZHGOROD: 'EUROPE_UZHGOROD',
  EUROPE_VADUZ: 'EUROPE_VADUZ',
  EUROPE_VIENNA: 'EUROPE_VIENNA',
  EUROPE_VILNIUS: 'EUROPE_VILNIUS',
  EUROPE_VOLGOGRAD: 'EUROPE_VOLGOGRAD',
  EUROPE_WARSAW: 'EUROPE_WARSAW',
  EUROPE_ZAGREB: 'EUROPE_ZAGREB',
  EUROPE_ZAPOROZHYE: 'EUROPE_ZAPOROZHYE',
  EUROPE_ZURICH: 'EUROPE_ZURICH',
  INDIAN_ANTANANARIVO: 'INDIAN_ANTANANARIVO',
  INDIAN_CHAGOS: 'INDIAN_CHAGOS',
  INDIAN_CHRISTMAS: 'INDIAN_CHRISTMAS',
  INDIAN_COCOS: 'INDIAN_COCOS',
  INDIAN_COMORO: 'INDIAN_COMORO',
  INDIAN_KERGUELEN: 'INDIAN_KERGUELEN',
  INDIAN_MAHE: 'INDIAN_MAHE',
  INDIAN_MALDIVES: 'INDIAN_MALDIVES',
  INDIAN_MAURITIUS: 'INDIAN_MAURITIUS',
  INDIAN_MAYOTTE: 'INDIAN_MAYOTTE',
  INDIAN_REUNION: 'INDIAN_REUNION',
  PACIFIC_APIA: 'PACIFIC_APIA',
  PACIFIC_AUCKLAND: 'PACIFIC_AUCKLAND',
  PACIFIC_CHATHAM: 'PACIFIC_CHATHAM',
  PACIFIC_EASTER: 'PACIFIC_EASTER',
  PACIFIC_EFATE: 'PACIFIC_EFATE',
  PACIFIC_ENDERBURY: 'PACIFIC_ENDERBURY',
  PACIFIC_FAKAOFO: 'PACIFIC_FAKAOFO',
  PACIFIC_FIJI: 'PACIFIC_FIJI',
  PACIFIC_FUNAFUTI: 'PACIFIC_FUNAFUTI',
  PACIFIC_GALAPAGOS: 'PACIFIC_GALAPAGOS',
  PACIFIC_GAMBIER: 'PACIFIC_GAMBIER',
  PACIFIC_GUADALCANAL: 'PACIFIC_GUADALCANAL',
  PACIFIC_GUAM: 'PACIFIC_GUAM',
  PACIFIC_HONOLULU: 'PACIFIC_HONOLULU',
  PACIFIC_JOHNSTON: 'PACIFIC_JOHNSTON',
  PACIFIC_KIRITIMATI: 'PACIFIC_KIRITIMATI',
  PACIFIC_KOSRAE: 'PACIFIC_KOSRAE',
  PACIFIC_KWAJALEIN: 'PACIFIC_KWAJALEIN',
  PACIFIC_MAJURO: 'PACIFIC_MAJURO',
  PACIFIC_MARQUESAS: 'PACIFIC_MARQUESAS',
  PACIFIC_MIDWAY: 'PACIFIC_MIDWAY',
  PACIFIC_NAURU: 'PACIFIC_NAURU',
  PACIFIC_NIUE: 'PACIFIC_NIUE',
  PACIFIC_NORFOLK: 'PACIFIC_NORFOLK',
  PACIFIC_NOUMEA: 'PACIFIC_NOUMEA',
  PACIFIC_PAGOPAGO: 'PACIFIC_PAGOPAGO',
  PACIFIC_PALAU: 'PACIFIC_PALAU',
  PACIFIC_PITCAIRN: 'PACIFIC_PITCAIRN',
  PACIFIC_PONAPE: 'PACIFIC_PONAPE',
  PACIFIC_PORTMORESBY: 'PACIFIC_PORTMORESBY',
  PACIFIC_RAROTONGA: 'PACIFIC_RAROTONGA',
  PACIFIC_SAIPAN: 'PACIFIC_SAIPAN',
  PACIFIC_TAHITI: 'PACIFIC_TAHITI',
  PACIFIC_TARAWA: 'PACIFIC_TARAWA',
  PACIFIC_TONGATAPU: 'PACIFIC_TONGATAPU',
  PACIFIC_TRUK: 'PACIFIC_TRUK',
  PACIFIC_WAKE: 'PACIFIC_WAKE',
  PACIFIC_WALLIS: 'PACIFIC_WALLIS'
})
export default LocalTimeZone
// RESERVE BELOW
